
import { Component, Vue } from 'vue-property-decorator'
import UnorderedListBase from '@/components/atoms/UnorderedListBase.vue'

/**
 * ulタグ
 */
@Component({
  components: {
    UnorderedListBase,
  },
})
export default class UnorderedList extends Vue {}
